// extracted by mini-css-extract-plugin
export default {"component":"TextField_component__TRsvx","labelName":"TextField_labelName__w-tsA","dark":"TextField_dark__8k3uZ"};